import { Injectable } from '@angular/core'
import { IAutomationDefaultMessages } from '@employer/app/components/jobs-automation/automation-form.model'
import { E11ErrorHandlerService } from '@engineering11/web-api-error'
import { ComponentStore } from '@ngrx/component-store'
import { tapResponse } from '@ngrx/operators'
import { finalize, Observable, switchMap } from 'rxjs'
import { JobDefaultAutomationService } from './job-default-automation.service'

export interface IJobDefaultAutomationStore {
  defaultMessage?: IAutomationDefaultMessages
  loaded: boolean
}

const initialState: IJobDefaultAutomationStore = {
  loaded: false,
}

@Injectable({ providedIn: 'root' })
export class JobDefaultAutomationStore extends ComponentStore<IJobDefaultAutomationStore> {
  constructor(private jobDefaultAutomationService: JobDefaultAutomationService, private errorHandler: E11ErrorHandlerService) {
    super(initialState)
  }

  // SELECTORS
  readonly getState = this.select(s => s)
  readonly defaultMessage$: Observable<IAutomationDefaultMessages | undefined> = this.select(s => s.defaultMessage)
  readonly loaded$ = this.select(s => s.loaded)

  // EFFECTS
  readonly onGetAutomationForJobPost = this.effect(($: Observable<undefined>) =>
    $.pipe(
      switchMap(_ => {
        this.setLoaded(false)
        return this.jobDefaultAutomationService.getAutomationDefaultMessageForJob().pipe(
          tapResponse(
            res => this.setDefaultAutomation({ ...res }),
            (err: Error) => this.errorHandler.handleError(err, { alertUser: true })
          ),
          finalize(() => this.setLoaded(true))
        )
      })
    )
  )

  // UPDATERS
  private readonly setDefaultAutomation = this.updater((s, defaultMessage: IAutomationDefaultMessages) => ({
    ...s,
    loaded: true,
    defaultMessage,
  }))

  private readonly setLoaded = this.updater((s, loaded: boolean) => ({ ...s, loaded }))
}
